import React, { FC } from 'react';
import { Box, Card, Typography, Grid } from '@mui/material';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import ProgressList, { type ProgressListItem } from './ProgressList';

interface SalesCallsMadeProps {
  managerPerformanceItems: ProgressListItem[];
  companyEngagementItems: ProgressListItem[];
  isLoading: boolean;
  activityLoading: boolean;
  selectedManager: string | number;
}

const SalesCallsMade: FC<SalesCallsMadeProps> = ({
  managerPerformanceItems,
  companyEngagementItems,
  isLoading,
  activityLoading,
  selectedManager,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={6}>
        <Card
          sx={{
            p: 3,
            borderRadius: 2,
            backgroundColor: '#fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
            Sales Calls Made - Company Wise{' '}
            {managerPerformanceItems.length > 0 && `(${managerPerformanceItems.length})`}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            Today's call velocity compared with weekly and monthly averages.
          </Typography>
          <Box sx={{ flex: 1, minHeight: 0, maxHeight: '500px' }}>
            <SimpleBar style={{ maxHeight: '100%', height: '100%' }}>
              <ProgressList
                items={managerPerformanceItems}
                loading={isLoading && !managerPerformanceItems.length}
                emptyLabel="No manager stats available"
                hideProgressBar={true}
              />
            </SimpleBar>
          </Box>
        </Card>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Card
          sx={{
            p: 3,
            borderRadius: 2,
            backgroundColor: '#fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
            Sales Calls Made - Manager Wise{' '}
            {companyEngagementItems.length > 0 && `(${companyEngagementItems.length})`}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            Companies touched today and their recent activity levels.
          </Typography>
          <Box sx={{ flex: 1, minHeight: 0, maxHeight: '500px' }}>
            <SimpleBar style={{ maxHeight: '100%', height: '100%' }}>
              <ProgressList
                items={companyEngagementItems}
                loading={activityLoading && !companyEngagementItems.length}
                emptyLabel={
                  selectedManager
                    ? 'No company engagement data available'
                    : 'Select an executive to view company engagement'
                }
                hideProgressBar={true}
              />
            </SimpleBar>
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SalesCallsMade;

